import { Accepts, Types } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class VRMediaBranchProps {
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.XR360Renderable) public renderable!: Types["XR360Renderable"];
  @Inlet(Accepts.XRHotspotList) public hotspots?: Types["XRHotspotList"];

  @Inlet(Accepts.Boolean) public allowReselecting?: Types["Boolean"];

  @Inlet(Accepts.Boolean) public debugHotspots?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public enableHotspotEffect?: Types["Boolean"];
  @Inlet(Accepts.Number) public startOffset?: number;

  @Outlet({
    arguments: {
      option: {
        type: Accepts.XRHotspot,
        inlet: "hotspots",
      },
    },
    repeatable: true,
  })
  public chosenOption?: (value: { option: Types["XRHotspot"] }) => void;

  @Outlet({
    arguments: {
      hotspot: {
        type: Accepts.XRHotspot,
        inlet: "hotspots",
      },
    },
    repeatable: true,
  })
  public chosenHotspot?: (value: { hotspot: Types["XRHotspot"] }) => void;
}

export const VRMediaBranchDefinition = defineElement(
  "vr-media-branch",
  VRMediaBranchProps,
  {
    versionRequired: "0.36.2",
  }
);
